import React, { ChangeEvent, useCallback } from 'react'
import { RelationsType, WorkItemType } from '../../../api/projects-api'
import { Grid, InputLabel, Table, TableBody, TableCell, TableHead, TableRow, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { addFileTC } from '../../TasksList/tasks-reducer';
import { AppRootState } from '../../../app/store';
import { AttachedItemsList } from './AttachedItemsList';
import { AddFirstAttachment } from '../../common/AddFirstAttachment';
import { ButtonAddAttachment } from '../../common/ButtonAddAttachment';

type TaskDetailsPropsType = {
  projectId: number
  projectName: string
  taskId: number
}

export const WorkItemAttachments = React.memo((props: TaskDetailsPropsType) => {
  const dispatch = useDispatch()
  const workItems = useSelector<AppRootState, Array<WorkItemType>>(state => state.workItems.workItemsState[props.projectName])

  let item = {} as WorkItemType
  if (workItems) {
    item = workItems.find(i => i.id === props.taskId) as WorkItemType
  }

  let relations = item.relations

  const addFile = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    let file: any
    if (event.target.files) {
      file = event.target.files[0]
      console.log(file)
      let f = new Blob([file])
      let formData = new FormData()
      formData.append("formdata", file)
      console.log(f)
      dispatch(addFileTC({
        projectName: props.projectName, projectId: props.projectId,
        fileName: file.name, formData, taskId: item.id
      }))
    }
  }, [])

  if (!relations) {
    relations = [] as Array<RelationsType>
  }

  let attachedFiles: Array<RelationsType> = relations.filter(obj => obj.rel === 'AttachedFile')

  if (attachedFiles.length === 0) {
    return <AddFirstAttachment addFile={addFile} />
  }

  return (
    <>
      <Typography>
        <b>Attachments</b>
      </Typography>
      <hr />
      <Grid container style={{ display: 'flex', margin: '10px', padding: '3px', fontSize: '14px' }} >
        <ButtonAddAttachment onClickButton={addFile} text='Add attachment' />
      </Grid>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell >
              Name
            </TableCell>
            <TableCell >
              Size
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              Date Attached
            </TableCell>
            <TableCell style={{ textAlign: 'center' }}>
              <span style={{ cursor: 'pointer', marginLeft: '5px' }}></span>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <AttachedItemsList projectName={props.projectName} taskId={props.taskId} projectId={props.projectId} relations={attachedFiles} />
        </TableBody>
      </Table>
    </>
  )
})
